import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var LedgerListRes;
export const LedgerListTodo = createAsyncThunk('LedgerList', async (data) => {
    // console.log("data", data)
    const type = localStorage.getItem('type')
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'pdf_account_padger',
            data: {
                "vfrom_date": data?.fromDate,
                "vto_date": data?.toDate,
                "vaccount_name": localStorage.getItem('vplant_name'),
                "vaccount_code": localStorage.getItem('vcust_plant_code'),
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id')
            },
            headers: { "Content-Type": "application/json" },

        })
        return LedgerListRes = res.data

    } catch (error) {
        return LedgerListRes = error.response.data
    }
});

// const LedgerListSlice = createSlice({
//     name: 'LedgerList',
//     initialState: {
//         data: null,
//     },
//     extraReducers: (builder) => {
//         builder.addCase(LedgerListTodo.fulfilled, (state, action) => {
//             state.data = action.payload;
//             // console.log('userList', state.data)
//         });
//         builder.addCase(LedgerListTodo.rejected, (state, action) => {
//             // console.log('token_error', action)
//         })
//     }
// });

// export default LedgerListSlice.reducer; 